import { FC } from 'react';
import { Box } from '@mui/material';

interface IBlackOverlayProps {
	open: boolean;
	onClick?: () => void;
}

export const BlackOverlay: FC<IBlackOverlayProps> = ({ open, onClick }) => {
	if (!open) return null;

	return (
		<Box
			onClick={onClick}
			sx={{
				position: 'fixed',
				inset: 0,
				background: 'rgba(0, 0, 0, 0.5)',
				zIndex: 1299,
			}}
		/>
	);
};
